<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">

    <!-- Header -->
    <div
        class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between p-6 sm:py-8 sm:px-10 border-b bg-card dark:bg-transparent">
        <div class="flex-1 min-w-0">
            <!-- Breadcrumbs -->
            <div>
                <div class="hidden sm:flex flex-wrap items-center font-medium">
                    <div>
                        <a class="whitespace-nowrap text-primary-500">Projects</a>
                    </div>
                    <div class="flex items-center ml-1 whitespace-nowrap">
                        <mat-icon
                            [svgIcon]="'heroicons_solid:chevron-right'"
                            class="icon-size-5 text-secondary"></mat-icon>
                        <a class="ml-1 text-primary-500">Weekend Project</a>
                    </div>
                    <div class="flex items-center ml-1 whitespace-nowrap">
                        <mat-icon
                            [svgIcon]="'heroicons_solid:chevron-right'"
                            class="icon-size-5 text-secondary"></mat-icon>
                        <span class="ml-1 text-secondary">Overview</span>
                    </div>
                </div>
                <div class="flex sm:hidden">
                    <a
                        [routerLink]="'./..'"
                        class="inline-flex items-center -ml-1.5 text-secondary font-medium">
                        <mat-icon
                            [svgIcon]="'heroicons_solid:chevron-left'"
                            class="icon-size-5 text-secondary"></mat-icon>
                        <span class="ml-1">Back</span>
                    </a>
                </div>
            </div>
            <!-- Title -->
            <div class="mt-2">
                <h2 class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
                    Page heading
                </h2>
            </div>
        </div>
        <!-- Actions -->
        <div class="flex flex-shrink-0 items-center mt-6 sm:mt-0 sm:ml-4">
            <button
                (click)="matDrawer.toggle()"
                mat-icon-button>
                <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
            </button>
        </div>
    </div>

    <mat-drawer-container class="flex-auto h-full">

        <!-- Drawer -->
        <mat-drawer
            #matDrawer
            [autoFocus]="false"
            [mode]="drawerMode"
            [opened]="drawerOpened"
            class="w-72 dark:bg-gray-900">
            <!-- Demo sidebar -->
            <table-sidebar></table-sidebar>
        </mat-drawer>

        <!-- Drawer content -->
        <mat-drawer-content class="flex flex-col">

            <!-- Main -->
            <div class="flex-auto p-6 sm:p-10">

                <!-- CONTENT GOES HERE -->
                <div class="h-400 min-h-400 max-h-400">
                    <ng-content select="[content]"></ng-content>
                </div>

            </div>

        </mat-drawer-content>

    </mat-drawer-container>

</div>
